import Vue from "vue";
import jsonApiFilterManager from "@/lib/JsonApiFilterManager";
import { restClient } from "../../lib/raftApi";

const state = {
  requirementStatuses: [],
  displayOptions: [],
  selectedRequirementStatuses: [],
  selectedCriteria: {},
  selectedSatisfiers: {},
  requirementStateOptions: [
    { value: "open", text: "Not Completed" },
    // {value: 'completed', text: 'Completed'},
    // {value: 'not_completed', text: 'Not Completed'},
    { value: "delinquent", text: "Delinquent" },
    // {value: 'canceled', text: 'Canceled'},
    // {value: 'exempt', text: 'Exempt'},
  ],
  selectedRequirementStateOptions: [],
  selectedWorkflowStates: [],
  selectedRelatedStates: [],
  nextDueBetweenStart: "",
  nextDueBetweenEnd: "",
  recordDateBetweenStart: "",
  recordDateBetweenEnd: "",
  userTextFilter: "",
  requirementListingFilters: {},
  requirementListingFilterUpdate: "",
  schedulerOptions: {},
  dateOffset: {},
  requirementOverrides: [],
  requirementRuleId: null,
  requirementsIntegrationPlugins: [],
  requirementRules: [],
  requirementRuleFilter: [],
  startDateFilter: "",
  endDateFilter: "",
};

const mutations = {
  setSelectedRequirementStatuses: (state, statuses) =>
    (state.selectedRequirementStatuses = statuses),
  setNextDueBetweenStart: (state, date) => (state.nextDueBetweenStart = date),
  setNextDueBetweenEnd: (state, date) => (state.nextDueBetweenEnd = date),
  setRecordBetweenStart: (state, date) => (state.recordDateBetweenStart = date),
  setRecordBetweenEnd: (state, date) => (state.recordDateBetweenEnd = date),
  setUserTextFilter: (state, user) => (state.userTextFilter = user),
  setRequirementListingFilters: (state, filters) =>
    (state.requirementListingFilters = filters),
  setRequirementListingFilterUpdate: (state, filters) =>
    (state.requirementListingFilterUpdate = filters),
  setSelectedCriteria: (state, criteria) => (state.selectedCriteria = criteria),
  setSelectedSatisfiers: (state, satisfiers) =>
    (state.selectedSatisfiers = satisfiers),
  setSchedulerOptions: (state, scheduler_options) =>
    (state.schedulerOptions = scheduler_options),
  setDateOffset: (state, date_offset) => (state.dateOffset = date_offset),
  setRequirementOverrides: (state, overrides) =>
    (state.requirementOverrides = overrides),
  setRequirementRuleId: (state, id) => (state.requirementRuleId = id),
  setSelectedRequirementStateOptions: (state, states) =>
    (state.selectedRequirementStateOptions = states),
  setRequirementsIntegrationPlugins: (state, states) =>
    (state.requirementsIntegrationPlugins = states),
  setRequirementRules: (state, requirementRules) =>
    (state.requirementRules = requirementRules),
  setRequirementRuleFilter: (state, types) =>
    (state.requirementRuleFilter = types),
  setStartDateFilter: (state, types) => (state.startDateFilter = types),
  setEndDateFilter: (state, types) => (state.endDateFilter = types),
};
const getters = {
  getRequirementStatuses: (state) => state.requirementStatuses,
  getSelectedRequirementStatuses: (state) => state.selectedRequirementStatuses,
  getNextDueBetweenStart: (state) => state.nextDueBetweenStart,
  getNextDueBetweenEnd: (state) => state.nextDueBetweenEnd,
  getRecordBetweenStart: (state) => state.recordDateBetweenStart,
  getRecordBetweenEnd: (state) => state.recordDateBetweenEnd,
  getUserTextFilter: (state) => state.userTextFilter,
  getRequirementListingFilters: (state) => state.requirementListingFilters,
  getRequirementListingFilterUpdate: (state) =>
    state.requirementListingFilterUpdate,
  getSelectedCriteria: (state) => state.selectedCriteria,
  getSelectedSatisfiers: (state) => state.selectedSatisfiers,
  getSchedulerOptions: (state) => state.schedulerOptions,
  getDateOffset: (state) => state.dateOffset,
  getRequirementOverrides: (state) => state.requirementOverrides,
  getRequirementRuleId: (state) => state.requirementRuleId,
  getRequirementStateOptions: (state) => state.requirementStateOptions,
  getSelectedRequirementStateOptions: (state) =>
    state.selectedRequirementStateOptions,
  getRequirementsIntegrationPlugins: (state) =>
    state.requirementsIntegrationPlugins,
  getRequirementRules: (state) => state.requirementRules,
  getRequirementRuleFilter: (state) => state.requirementRuleFilter,
  getStartDateFilter: (state) => state.startDateFilter,
  getEndDateFilter: (state) => state.endDateFilter,
};

const actions = {
  clearFilters({ commit }) {
    commit("setSelectedRequirementStatuses", []);
    commit("setNextDueBetweenStart", "");
    commit("setNextDueBetweenEnd", "");
    commit("setUserTextFilter", "");
    commit("setRequirementRuleFilter", []);
    commit("setStartDateFilter", "");
    commit("setEndDateFilter", "");
  },
  updateSelectedRequirementStatuses({ commit }, value) {
    commit("setSelectedRequirementStatuses", value);
    commit("setRequirementListingFilterUpdate", new Date().getTime());
  },
  updateSelectedRequirementStateOptions({ commit }, value) {
    commit("setSelectedRequirementStateOptions", value);
    commit("setRequirementListingFilterUpdate", new Date().getTime());
    const states = value.map((item) => item.value);
    if (states) {
      Vue.set(state.requirementListingFilters, "state", states);
    } else {
      Vue.delete(state.requirementListingFilters, "state");
    }
  },
  updateNextDueBetweenEnd({ commit, state }, value) {
    commit("setNextDueBetweenEnd", value);
    commit("setRequirementListingFilterUpdate", new Date().getTime());
    let date = new Date(value);
    if (value) {
      date =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 24:59:59";
      Vue.set(state.requirementListingFilters, "due_date_end", date);
    } else {
      Vue.delete(state.requirementListingFilters, "due_date_end");
    }
  },
  updateNextDueBetweenStart({ commit, state }, value) {
    commit("setNextDueBetweenStart", value);
    commit("setRequirementListingFilterUpdate", new Date().getTime());
    let date = new Date(value);
    if (value) {
      date =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 00:00:00";
      Vue.set(state.requirementListingFilters, "due_date_start", date);
    } else {
      Vue.delete(state.requirementListingFilters, "due_date_start");
    }
  },
  updateRecordDateBetweenStart({ commit, state }, value) {
    commit("setRecordBetweenEnd", value);
    commit("setRequirementListingFilterUpdate", new Date().getTime());
    let date = new Date(value);
    if (value) {
      date =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 00:00:00";
      Vue.set(
        state.requirementListingFilters,
        "field_med_surv_record_date_start",
        date,
      );
    } else {
      Vue.delete(
        state.requirementListingFilters,
        "field_med_surv_record_date_start",
      );
    }
  },
  updateRecordDateBetweenEnd({ commit, state }, value) {
    commit("setRecordBetweenEnd", value);
    commit("setRequirementListingFilterUpdate", new Date().getTime());
    let date = new Date(value);
    if (value) {
      date =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 23:59:59";
      Vue.set(
        state.requirementListingFilters,
        "field_med_surv_record_date_end",
        date,
      );
    } else {
      Vue.delete(
        state.requirementListingFilters,
        "field_med_surv_record_date_end",
      );
    }
  },
  updateRecordFileAttachments({ commit }, value) {
    commit("setRecordFileAttachments", value);
  },
  updateUserTextFilter({ commit, state, getters }, value) {
    commit("setUserTextFilter", value);
    if (value.length >= 2) {
      Vue.set(
        state.requirementListingFilters,
        "field_prof_display_name_value",
        value,
      );
    } else {
      Vue.delete(
        state.requirementListingFilters,
        "field_prof_display_name_value",
      );
    }
    // Trigger table filtering for anything except a 1 character entry.
    if (value.length !== 1) {
      commit("setRequirementListingFilterUpdate", new Date().getTime());
    }
    if (value) {
      jsonApiFilterManager.addFilter(
        "exempt_user",
        "exempted_user.field_prof_display_name",
        getters.getUserTextFilter,
        "CONTAINS",
      );
    } else {
      jsonApiFilterManager.deleteFiltersByName(["exempt_user"]);
    }
  },
  updateSelectedRelatedStates({ commit }, value) {
    commit("setSelectedRelatedStates", value);
    commit("setRequirementListingFilterUpdate", new Date().getTime());
    const states = value.map((item) => item.value);
    if (states) {
      Vue.set(
        state.requirementListingFilters,
        "field_med_surv_record_status_value",
        states,
      );
    } else {
      Vue.delete(
        state.requirementListingFilters,
        "field_med_surv_record_status_value",
      );
    }
  },
  updateSelectedCriteria({ commit }, value) {
    commit("setSelectedCriteria", value);
  },
  updateSelectedSatisfiers({ commit }, value) {
    commit("setSelectedSatisfiers", value);
  },
  updateSchedulerOptions({ commit }, value) {
    commit("setSchedulerOptions", value);
  },
  updateDateOffset({ commit }, value) {
    commit("setDateOffset", value);
  },
  updateRequirementRuleSummary({ commit }, value) {
    commit("setRequirementRuleSummary", value);
  },
  updateRequirementOverrides({ commit }, value) {
    commit("setRequirementOverrides", value);
  },
  updateRequirementRuleId({ commit }, value) {
    commit("setRequirementRuleId", value);
  },
  updateRequirementRuleFilter({ commit, getters }, { value, filterKey }) {
    commit("setRequirementRuleFilter", value);
    if (getters.getRequirementRuleFilter.length) {
      const ruleIds = [];
      getters.getRequirementRuleFilter.forEach((ruleinfo) =>
        ruleIds.push(ruleinfo.id),
      );
      return jsonApiFilterManager.addMultivalueNamedFilter(
        filterKey,
        "requirement_rule.id",
        ruleIds,
      );
    }
    return jsonApiFilterManager.deleteFiltersByName([filterKey]);
  },
  updateStartDateFilter({ commit }, { value, filterKey }) {
    commit("setStartDateFilter", value);
    if (value) {
      return jsonApiFilterManager.addFilter(
        filterKey,
        "date_range.value",
        value,
        ">=",
      );
    }
    return jsonApiFilterManager.deleteFiltersByName([filterKey]);
  },
  updateEndDateFilter({ commit }, { value, filterKey }) {
    commit("setEndDateFilter", value);
    if (value) {
      return jsonApiFilterManager.addFilter(
        filterKey,
        "date_range.end_value",
        value,
        "<=",
      );
    }
    return jsonApiFilterManager.deleteFiltersByName([filterKey]);
  },
  updateDateRangeFilter({ commit, dispatch }, payload) {
    if (payload.filterKey.includes("-end")) {
      return dispatch("updateEndDateFilter", payload);
    }
    return dispatch("updateStartDateFilter", payload);
  },
  async fetchRequirementsIntegrationPlugins({ commit }, bundle) {
    const options = {
      path: "requirements-updates-bundles",
      queries: { bundle: bundle },
    };
    const data = await restClient
      .get(options)
      .catch((error) => console.error(error)); // eslint-disable-line no-console
    commit("setRequirementsIntegrationPlugins", data);
  },
  async fetchRequirementRules({ commit }) {
    const options = {
      path: "requirement-rules",
      queries: {},
    };
    const data = await restClient
      .get(options)
      .catch((error) => console.error(error)); // eslint-disable-line no-console
    const rules = [];
    for (const bundleRules of Object.values(data)) {
      bundleRules.forEach((rule) => {
        rules.push({
          id: rule.uuid,
          type: "requirement_rule--" + rule.type,
          key: rule.uuid,
          name: rule.label,
          bundle: rule.type,
        });
      });
    }
    rules.sort((a, b) => (a.name > b.name ? 1 : -1));
    commit("setRequirementRules", rules);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
